export default __webpack_public_path__ + "static/media/AOCC_supervisor.7433d0af.svg";